import { useEffect, useState } from "react";
import BriefingTable from "components/Briefing/subcomponents/table";

import { useSelector } from "react-redux";
import Actions from "components/Briefing/subcomponents/actions"; // Fixed typo (Actoins -> Actions)
import { briefingTrailersAPI } from "components/Apis/Briefing";
import { TextField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import HistoryViewer from "components/Briefing/subcomponents/safety-subcomponents/historyViewer";
import toast from "react-hot-toast";

const TrailerReports = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const currentTerminal = useSelector((state) => state.TerminalSlice.currentTerminal);
    const briefing = useSelector((state) => state.briefing.line);
    const archived = (briefing === "Old Briefings");

    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            if (archived) {
                const requestPayload = {
                    "startDate": startDate,
                    "endDate": endDate,
                    "searchTerm": searchTerm
                }
                const response = await briefingTrailersAPI.getArchive(requestPayload);
                setData(response.data);
            }
            else {
                const response = await briefingTrailersAPI.filter({
                    archived: false,
                    terminal: currentTerminal ? currentTerminal.id : 'None'
                });
                setData(response.data);
            }
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing, currentTerminal]);

    const headers = [
        "ID",
        "Trailer",
        "Location",
        "Notes",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={`safety-trailer-row-${row.id}`} className="safety-row">
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td style={{ width: "15%" }}>
                    <TextField row={row} label={"trailer"} onBackendSync={briefingTrailersAPI.update} />
                </td>
                <td style={{ width: "15%" }}>
                    <TextField row={row} label={"location"} maxLength={50} onBackendSync={briefingTrailersAPI.update} />
                </td>
                <td>
                    <TextField row={row} label={"notes"} maxLength={500} onBackendSync={briefingTrailersAPI.update} />
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={() => (
                            briefingTrailersAPI.delete(row.id).then(() => {
                                setRefresh(!refresh);
                            }).catch((error) => {
                                toast.error(error.response?.data?.msg || "An error occurred while deleting the trailer.");
                            })
                        )}
                        onArchive={() => (
                            briefingTrailersAPI.update(row.id, { archived: true }).then(() => {
                                setRefresh(!refresh);
                            })
                        )}
                    />
                </td>
            </tr>
            <tr>
                <td colSpan={headers.length - 1} className="pt-0 pb-1">
                    <span className="input-updated-at-label">
                        Updated by: {row.updated_by ? row.updated_by : "Unknown"} {row.updated_at ? row.updated_at : "Never"}
                    </span>
                </td>
            </tr>
        </>
    );

    if (archived && !data.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h1>
                    Trailers out of service
                </h1>
                <HistoryViewer
                    historyAPICall={briefingTrailersAPI.getHistory}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={async () => {
                    await briefingTrailersAPI.create({
                        terminal: currentTerminal?.id
                    })
                    setRefresh(!refresh);
                }}
            />
        </>
    );
};

export default TrailerReports;
